;
(function(win, doc) {
    if (!IsPC()) {
        var resize = 'orientationchange' in window ? 'orientationchange' : 'resize'
            /* 使用rem 动态计算跟font-size值  */
        function resizeRoot() {
            var wWidth = (win.screen.width > 0) ?
                ((win.innerWidth >= win.screen.width || win.innerWidth === 0) ? win.screen.width : win.innerWidth) :
                win.innerWidth
            var wFsize = (wWidth > 750 ? 750 : wWidth) / 750 * 100
            doc.documentElement.style.fontSize = wFsize + 'px'
        }
        win.addEventListener(resize, resizeRoot, false)
        doc.addEventListener('DOMContentLoaded', resizeRoot, false)
    }
})(window, document)

function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}


// WEBPACK FOOTER //
// ./src/assets/js/rem.js